// @flow
/* eslint-disable camelcase */
import jsCookie from "js-cookie"

import cuckoo from "common/services/cuckoo/cuckoo"
import { cuckooEvents } from "common/consts/enums"
import { UA_SESSION_TOKEN, EXPIRY_DAYS } from "common/consts/auth"
import { parseQuery, removeParams } from "common/services/query/queries"

function removeAuthParamsFromWindowLocation() {
  const queryWithoutAuth = removeParams(window.location.search, "oauth-login", "auth_token")

  if (window.history) {
    window.history.replaceState({}, window.title, window.location.pathname + queryWithoutAuth)
  } else {
    window.location.search = queryWithoutAuth
  }
}

export default function oauthRedirect() {
  try {
    const { auth_token, error_code } = parseQuery(window.location.search)

    if (error_code) {
      cuckoo.track(cuckooEvents.AUTH_LOGIN_OAUTH_REDIRECT_ERROR, { error: error_code })
    } else {
      jsCookie.set(UA_SESSION_TOKEN, auth_token, {
        ...window.Skypicker.cookieOptions,
        expires: EXPIRY_DAYS, // https://github.com/js-cookie/js-cookie#basic-usage
      })
      removeAuthParamsFromWindowLocation()
    }
  } catch (error) {
    cuckoo.track(cuckooEvents.AUTH_LOGIN_OAUTH_REDIRECT_ERROR, { error: String(error) })
  }
}
